// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__11bJM","info":"UpdateTermsInfo_info__2wuGf"};